import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon, Label, Menu } from 'semantic-ui-react';
import { useInterval } from '../../hooks/useInterval';
import NotificationsRepo from '../../utils/repository/notificationsRepo';
import './notificationBell.styles.css';

const POLL_INTERVAL_MS = 2 * 60 * 1000;

function NotificationBell() {
    const [unreadCount, setUnreadCount] = useState(0);

    const fetchUnreadCount = () => {
        NotificationsRepo.getUnreadCount(
            (response) => setUnreadCount(response.data),
            () => {}
        );
    };

    useEffect(() => {
        fetchUnreadCount();
    }, []);

    useInterval(fetchUnreadCount, POLL_INTERVAL_MS);

    return (
        <Menu.Item as={Link} to="/notifications" className="notification-bell noBorder">
            <Icon name="bell outline" />
            {unreadCount > 0 && (
                <Label color="red" circular size="mini" floating>
                    {unreadCount}
                </Label>
            )}
        </Menu.Item>
    );
}

export default NotificationBell;
